import moment from 'moment';
import { storage } from 'BASE/common/util/util.storage';

// 修改預設設定
moment.locale('en', {
    week: {
        dow: 1 // 起始日為禮拜一
    }
});

export default {
    dateType: {
        today: 1,
        yesterday: 2,
        week: 3,
        month: 4,
        last_week: 5,
        helf_month: 6,
        last_month: 7,
        last_7days: 8,
        first_today: 9,
        last_15days: 10,
        last_3month: 11,
        last_helf_month: 12,
        last_7days_without_today: 13,
        other: -1
    },
    getFinancialDayDelimitation() {
        var delimit = storage.session.get(storage.keys.FINANCIAL_DAY_DELIMITATION);
        var res = parseInt(delimit, 10);
        if (!isNaN(res))
            return res;

        $.ajax({
            url: '/api/Report/GetFinancialDelimitation',
            async: false,
            type: 'GET',
            success: function (data) {
                storage.session.set(storage.keys.FINANCIAL_DAY_DELIMITATION, data);
                res = data;
            },
            error: function () {
                res = 7;
            }
        });
        return res;
    },
    getFinancialTimeStr() {
        return moment({ h: this.getFinancialDayDelimitation(), m: 0, s: 0, ms: 0 }).format("HH:mm");
    },
    getFinancialDay() {
        var nowHour = moment().hour();
        var today = moment({ h: this.getFinancialDayDelimitation(), m: 0, s: 0, ms: 0 });
        if (nowHour < this.getFinancialDayDelimitation()) {
            return today.add(-1, 'd');
        }
        return today;
    },
    getDateTimeStr(dateType, withHour) {
        withHour = typeof withHour === 'boolean' ? withHour : true;
        let _h = withHour ? this.getFinancialDayDelimitation() : 0;
        switch (dateType) {
            case this.dateType.today:
                return {
                    startTime: this.getFinancialDay().set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.yesterday:
                return {
                    startTime: this.getFinancialDay().add(-1, 'd').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 0 : -1), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.week:
                return {
                    startTime: this.getFinancialDay().startOf('week').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().endOf('week').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.last_week:
                return {
                    startTime: this.getFinancialDay().add(-7,'d').startOf('week').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add(-7,'d').endOf('week').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.month:
                return {
                    startTime: this.getFinancialDay().startOf('month').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().endOf('month').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.helf_month:
                var day = this.getFinancialDay().dates()
                if(day >= 16 )
                {
                    return {
                        startTime: this.getFinancialDay().startOf('month').set({ D: 16, h: _h, m: 0, s: 0, ms: 0 }),
                        endTime: this.getFinancialDay().endOf('month').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                    };             
                }
                else{
                    return {
                        startTime: this.getFinancialDay().startOf('month').set({ h: _h, m: 0, s: 0, ms: 0 }),
                        endTime: this.getFinancialDay().startOf('month').set({ D: 15, h: _h, m: 0, s: 0, ms: 0 }).add((withHour ? 1 : 0), 'd')
                    };
                }
            case this.dateType.last_helf_month:
                var day2 = this.getFinancialDay().dates()
                if(day2 >= 16 )
                {
                    return {
                        startTime: this.getFinancialDay().startOf('month').set({ D: 1, h: _h, m: 0, s: 0, ms: 0 }),
                        endTime: this.getFinancialDay().endOf('month').set({ D: 15, h: _h, m: 0, s: 0, ms: 0 })
                    };             
                }
                else{
                    return {
                        startTime: this.getFinancialDay().subtract(1, 'months').startOf('month').set({ D: 16, h: _h, m: 0, s: 0, ms: 0 }),
                        endTime: this.getFinancialDay().subtract(1, 'months').endOf('month').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                    };
                }

            case this.dateType.last_month:
                return {
                    startTime: this.getFinancialDay().add(-1,'M').startOf('month').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add(-1,'M').endOf('month').add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };

            case this.dateType.last_7days:
                return {
                    startTime: this.getFinancialDay().add(-6, 'd').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                }; 

            case this.dateType.last_15days:
                return {
                    startTime: this.getFinancialDay().add(-14, 'd').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                }; 
            case this.dateType.last_3month:
                return {
                    startTime: this.getFinancialDay().add(-3 ,'M').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.first_today:
                return {
                    startTime: this.getFinancialDay().startOf('month').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 1 : 0), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
            case this.dateType.last_7days_without_today:
                return {
                    startTime: this.getFinancialDay().add(-7, 'd').set({ h: _h, m: 0, s: 0, ms: 0 }),
                    endTime: this.getFinancialDay().add((withHour ? 0 : -1), 'd').set({ h: _h, m: 0, s: 0, ms: 0 })
                };
        }
    },
    formatDateTime(date) {
        return moment(date).format("YYYY/MM/DD HH:mm:ss");
    },
    formatDateTimeNoSeconds(date) {
        return moment(date).format("YYYY/MM/DD HH:mm");
    },
    formatDateTimeWithoutHour(date) {
        return moment(date).format("YYYY/MM/DD");
    },
    // 算出日期與日期間的差距有幾天
    dateDifferenceDay(startDate, endDate){
        let _startDate = startDate;
        let _endDate = endDate;
        if(typeof startDate === 'string')
            _startDate = new Date(startDate);
        
        if(typeof endDate === 'string')
            _endDate = new Date(endDate);
        
        //計算方式86400000是24*60*60*1000，除以86400000就是相差的天數
        return Math.round((_endDate - _startDate) / (24*60*60*1000)) ;
    },
};